import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid2'
import Skeleton from '@mui/material/Skeleton'
import Typography from '@mui/material/Typography'
import { filter, isUndefined, map } from 'lodash'
import { useEffect, useState } from 'react'
import { HeaderWrapper } from '../../../components/Wrapper/HeaderWrapper'
import { useSettingStore } from '../../../store/storeSetting'
import { useWrapperStore } from '../../../store/storeWrapper'
import { AiSetupForm } from './components/AiSetupForm'
import { ModelSetupForm, ModelSetupFormValues } from './components/ModelSetupForm'

export const ModelSetupPage = () => {
    const [initialValuesUserAi, setInitialValuesUserAi] = useState(undefined)
    const [initialValuesModel, setInitialValuesModel] = useState<ModelSetupFormValues>({
        model: [],
    })

    const { fetchModelList, modelListFull, errorModelList } = useWrapperStore((state) => state)
    const { fetchUserAi, userAi, isDoneUpdateModel, setIsDoneUpdateModel } = useSettingStore(
        (state) => state,
    )

    useEffect(() => {
        fetchUserAi()
        fetchModelList({ show_restricted: true })
    }, [])

    useEffect(() => {
        if (isDoneUpdateModel) {
            fetchModelList({ show_restricted: true })
            setIsDoneUpdateModel(false)
        }
    }, [isDoneUpdateModel])

    useEffect(() => {
        if (modelListFull) {
            const model = map(filter(modelListFull, { is_restricted: false }), 'slug')
            setInitialValuesModel({ model })
        }
    }, [modelListFull])

    useEffect(() => {
        if (userAi) {
            setInitialValuesUserAi({ mode: userAi.model_set_mode })
        }
    }, [userAi])

    return (
        <>
            <HeaderWrapper>
                <Typography
                    variant="Header3"
                    sx={{
                        color: '#1B1C1D'
                    }}>
                    Агрегатор нейросетей
                </Typography>
            </HeaderWrapper>
            {!isUndefined(errorModelList) && (
                <Grid container display="flex" flexDirection="column" size="12" m={3}>
                    <Box
                        sx={{
                            marginLeft: '8px',
                            marginBottom: '8px',
                            borderRadius: '12px',
                            background: '#2E3038',
                            padding: '24px',
                            border: '1px solid #E2FF94',
                        }}>
                        <Typography sx={{ color: '#fff' }}>
                            Подключи тариф и получи доступ к настройкам моделей
                        </Typography>
                        <Button
                            href="/finances?isOpenTariffDialog=true"
                            color="primary"
                            variant="contained"
                            sx={{
                                position: 'flex',
                                marginLeft: 'auto',
                                my: '16px',
                            }}>
                            Подключить
                        </Button>
                    </Box>
                </Grid>
            )}
            {initialValuesUserAi && initialValuesModel && modelListFull && userAi ? (
                <>
                    <AiSetupForm initialValues={initialValuesUserAi} userAi={userAi} />
                    <ModelSetupForm initialValues={initialValuesModel} modelList={modelListFull} />
                </>
            ) : (
                <Grid container sx={{ padding: '0 16px 16px 24px', width: '100%' }}>
                    <Skeleton
                        variant="rectangular"
                        width="90%"
                        height="28px"
                        sx={{ borderRadius: '24px', mb: '4px' }}
                    />
                    <Skeleton
                        variant="rectangular"
                        width="90%"
                        height="16px"
                        sx={{ borderRadius: '24px' }}
                    />
                    <Skeleton
                        variant="rectangular"
                        width="60%"
                        height="88px"
                        sx={{ borderRadius: '24px', my: 3 }}
                    />
                    <Skeleton
                        variant="rectangular"
                        width="90%"
                        height="28px"
                        sx={{ borderRadius: '24px', mb: '4px' }}
                    />
                    <Skeleton
                        variant="rectangular"
                        width="90%"
                        height="16px"
                        sx={{ borderRadius: '24px' }}
                    />
                    <Skeleton
                        variant="rectangular"
                        width="60%"
                        height="200px"
                        sx={{ borderRadius: '24px', my: 3 }}
                    />
                </Grid>
            )}
        </>
    )
}
